import { ButtonProps } from './Button.types';
import { useButton } from './useButton';

/**
 * Primary UI component for user interaction
 */
export const Button = ({
  type = 'button',
  style = 'primary',
  size = 'small',
  hasArrow = false,
  label,
  disabled = false,
  className = '',
  isDarkMode = false,
  edge = 'rounded',
  onClick,
  ...props
}: ButtonProps) => {
  const { buttonClassNames, buttonContent } = useButton({
    hasArrow,
    style,
    size,
    label,
    className,
    isDarkMode,
    edge,
  });

  return (
    <button
      data-test={`${label.toLowerCase().replace(/\s+/g, '-')}-button`}
      aria-label={label}
      type={type}
      className={buttonClassNames}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {buttonContent}
    </button>
  );
};
